import * as React from "react";
import {PropsWithChildren} from "react";

interface Props {
    gemeinde: string

};

interface State {
    checked: boolean
}

export default class ReactGemeindeText extends React.Component<PropsWithChildren<Props>, State> {
    constructor(props: Props) {

        super(props);
        this.state = {checked: false};
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(checked: boolean) {
        this.setState({checked});
    }

    render() {
        return (
            <div>
                     <text className="detailHeading">{this.props.gemeinde}</text>
            </div>
        );
    }
}